/**
 * Function validate forms
 * @param {*} form
 * @returns
 */
function validateForms(form) {
  const EL = (sel, parent) => (parent || document).querySelector(sel)
  const ELS = (sel, parent) => (parent || document).querySelectorAll(sel)
  const ELNew = (tag, prop) => Object.assign(document.createElement(tag), prop)

  // Form validation script:
  const elForm = EL(form)

  if (!elForm) {
    return
  }

  const validateForm = (evt) => {
    // Remove old errors
    ELS('.error.label', elForm).forEach((el) => el.remove())
    ELS('.error', elForm).forEach((el) => el.classList.remove('error'))

    // Prepare an array to hold your errors
    const errors = []

    // Validation and errors:
    if (form === '#contact_form') {
      // Get the desired fields:
      const elName = EL('[name="contact[name]"]', elForm)
      const elEmail = EL('[name="contact[email]"]', elForm)
      const elPhone = EL('[name="contact[phone]"]', elForm)

      if (elName.value.trim().length < 1) {
        errors.push({ name: 'contact[name]', text: "Full name can't be blank" })
      }

      if (elPhone.value.trim().length < 1) {
        errors.push({ name: 'contact[phone]', text: "Phone can't be blank" })
      }

      if (elEmail.value.trim().length < 1) {
        errors.push({ name: 'contact[email]', text: 'Please enter a valid email address.' })
      } else if (!/^.+@.+\./.test(elEmail.value)) {
        errors.push({ name: 'contact[email]', text: 'Invalid email address' })
      }
    }

    // Show errors:
    errors.forEach((err) => {
      const elError = ELNew('label', {
        className: 'text-xs text-error-content tracking-default',
        textContent: err.text
      })
      EL(`[name="${err.name}"]`, elForm).classList.add('border-invalid')
      EL(`[name="${err.name}"]`, elForm).closest('.field__input').append(elError)
    })

    // Prevent Form submit on any error
    if (errors.length) {
      evt.preventDefault()
    }
  }

  elForm.addEventListener('submit', (evt) => { validateForm(evt) })
}

/**
 * Defined validate current form
 */
validateForms('#contact_form')
